/**
 * OperatorSignedIn.contract.ts — OPERATOR IDENTITY™ Phase 1 (Build 2.06.0).
 * Published when an operator successfully authenticates (login or signup).
 */

import type { EventContract } from '../EventContractRegistry';

export const OperatorSignedInContract: EventContract = {
  name: 'OperatorSignedIn',
  version: 1,
  description: 'Published when an operator successfully authenticates (login or signup).',
  publishers: ['auth-event-service'],
  subscribers: [],
  fields: [
    { name: 'operatorId', type: 'number', required: true, description: 'Authenticated operator user ID' },
    { name: 'email', type: 'string', required: true, description: 'Operator email address' },
    { name: 'displayName', type: 'string', required: false, description: 'Display name, if set' },
    { name: 'rememberMe', type: 'boolean', required: false, description: 'Whether the session uses persistent cookie' },
  ],
  allowExtraFields: false,
  timestampPolicy: 'Set to Date.now() at publish time.',
  stability: 'stable',
  deprecated: false,
  example: { operatorId: 1, email: 'roamer@example.com', displayName: 'Alex Roamer', rememberMe: true },
};
